"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDuplicateCtrl = void 0;
var core_api_1 = require("@ikegps/core-api");
var i18n_1 = require("../../i18n");
var index_1 = require("../../services/index");
var page_state_1 = require("../../state/page.state");
var collection_duplicate_modal_1 = require("../collection.duplicate.modal/collection.duplicate.modal");
exports.CollectionDuplicateCtrl = {
    canDuplicate: function () {
        return ((index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_DUPLICATE) || index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) && index_1.Services.Token.has(core_api_1.IkeToken.TAG_JOB_UPDATE));
    },
    showDuplicateModal: function () {
        var collections = page_state_1.CurrentState.Tag.collections;
        var modal = new collection_duplicate_modal_1.CollectionDuplicateModal({
            title: i18n_1.T.COLLECTION_DUPLICATE_TITLE,
            confirm: i18n_1.T.COLLECTION_DUPLICATE,
            success: {
                key: i18n_1.T.COLLECTION_DUPLICATE_SUCCESS,
                attrs: {
                    count: collections.length
                }
            }
        }, collections);
        modal.open();
    }
};
//# sourceMappingURL=collection.duplicate.ctrl.js.map